import { Inject, Injectable } from '@angular/core';
import { EncryptionConfigService } from './encryption-config.service';
import { EncryptionHelper } from './encryption.helper';
import { EncryptionConfig } from './encryption.model';
const AES256  = require('aes-everywhere');

/*
* https://stackoverflow.com/questions/56846930/how-to-convert-raw-representations-of-ecdh-key-pair-into-a-json-web-key
*/

@Injectable()
export class EncryptionService {

    private sharedKey!: string;

    constructor(@Inject(EncryptionConfigService) private config: EncryptionConfig) {
        this.initialize();
    }
    // async test() : Promise<void> {
    //     // A - Client
    //     // B - Server
    //     // Generate an ECDH object for geekA
    //     // console.log(crypto.getCurves());
    //     const geekA = crypto.createECDH('prime256v1');

    //     // Generate an ECDH object for geekB
    //     const geekB = crypto.createECDH('prime256v1');

    //     // Generate the keys for both the geeks
    //     geekA.generateKeys();
    //     geekB.generateKeys();

    //     // Get the private key for geekA
    //     const geekAprivateKey = geekA.getPrivateKey();

    //     console.log("Private Key of Geek A is:",
    //     geekAprivateKey.toString('hex'));
    //     console.log("Public Key of Geek A is:",
    //     geekA.getPublicKey('hex', 'compressed'));
    //     // Get the private key for geekB
    //     const geekBprivateKey = geekB.getPrivateKey();

    //     console.log("Private Key of Geek B is:",
    //     geekBprivateKey.toString('hex'));
    //     console.log("Public Key of Geek B is:",    
    //     geekB.getPublicKey('hex', 'compressed'));

    //     console.log(geekA.computeSecret(geekB.getPublicKey('hex'), 'hex').toString('hex'));
    //     console.log(geekB.computeSecret(geekA.getPublicKey('hex'), 'hex').toString('hex'));
    // }

    async initialize(): Promise<void> {
        const publicKey = await crypto.subtle.importKey('raw', EncryptionHelper.hexToUintArray(this.config.serverPublicKey),
            {name: 'ECDH', namedCurve: 'P-256'}, true, []);
            // console.log(publicKey)

        const privateKey = await crypto.subtle.importKey('jwk',
            EncryptionHelper.jwkConv(this.config.clientPrivateKey, this.config.clientPublicKey),
            {name: 'ECDH', namedCurve: 'P-256'}, true, ['deriveKey', 'deriveBits']);
            // console.log(privateKey)

        const rawKey = await crypto.subtle.deriveBits({name: 'ECDH', public: publicKey}, privateKey, 256);

        this.sharedKey = EncryptionHelper.convertArrayBufferToHexaDecimal(rawKey);
    }

    // encrypt(value: string): string {
    //     return AES256.encrypt(value, this.sharedKey);
    // }

    // decrypt(value: string): string {
    //     return AES256.decrypt(value, this.sharedKey);
    // }
    encrypt(dataToEncrypt: any) : any {       
        const encData = JSON.stringify(dataToEncrypt);
        const encrypted = AES256.encrypt(encData, this.sharedKey);        
        return encrypted;
    }

    decrypt(dataToDecrypt: any) : any {
       
        const decrypted =  AES256.decrypt(dataToDecrypt, this.sharedKey);       
        const decryptedData = JSON.parse(decrypted);
        return decryptedData;
    }
}
